import { BillingQuestionComponent } from '../../dashboard/loggedin-content/billing/billing-question/billing-question.component';
import { UploadTypeModalComponent } from '../../screens/upload-type-modal/upload-type-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { WidgetContent } from '@models/widget/widget-content.interface';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, UploadTypeModalComponent, BillingQuestionComponent],
  selector: 'app-model-open-widget',
  templateUrl: './model-open-widget.component.html',
  styleUrls: ['./model-open-widget.component.css'],
})
export class ModelOpenWidgetComponent implements OnInit{
  @Input() widgetContent: WidgetContent;
  isAcmic: boolean;
  isLoading: boolean;
  isOpenModal: boolean;

constructor(       
  private acmicService: AcmicService,
){}

  public ngOnInit() {
    this.isLoading = true;
    this.isAcmic = this.acmicService.isACMIC();
    this.isLoading = false;
  }

   public onClick() {    
    this.isOpenModal = true;
  }

  closeModal(event: any){
    if(event)
      this.isOpenModal = false;
  }
}
